export const modules = {
  toolbar: [
      ['bold', 'underline'],
      [{ list: 'ordered' },{ list: 'bullet' }],
      ['link'],
  ],
};

export const formats = [
  'bold',  'underline',
  'list', 'bullet', 
  'link',
];


// WEBPACK FOOTER //
// ./src/share/config/quill.ts